import { StreakDayState } from 'src/utils/streak';

export type StreakDayLook = {
  disc: string;

  icon?: string;
};

const STREAK_DAY_GOLD =
  'bg-gradient-to-b from-warning-goldBright to-warning-neutral';

export const STREAK_DAY_LOOKS: Record<StreakDayState, StreakDayLook | null> = {
  completed: { disc: STREAK_DAY_GOLD, icon: 'Flame.svg' },
  milestone: { disc: STREAK_DAY_GOLD, icon: 'Flame.svg' },
  freeze: { disc: 'bg-streak-freeze', icon: 'streak/day-freeze.svg' },
  lost: { disc: 'bg-structural-light', icon: 'streak/day-lost.svg' },
  upcoming: null,
};

export const STREAK_STRIP_UPCOMING: StreakDayLook = {
  disc: 'bg-structural-lighter',
};
